import React from "react";
import UserDeletionRequestView from "./UserDeletionRequestView";

const UserDeletionRequestModule = () => {
  return <UserDeletionRequestView />;
};

export default UserDeletionRequestModule;
